import { memo } from 'react';
import PropTypes from 'prop-types';
import { DONUT_PIE_LABEL_MODE } from '../charts/pipeline/lib/orderPrimaryPhaseChartTheme';

const StatisticsDonutLabelModeSwitch = ({ mode, onChange }) => (
	<div className='statistics-donut-label-mode' role='group' aria-label='环形图标签显示'>
		<button
			type='button'
			className={['statistics-donut-label-mode__btn', mode === DONUT_PIE_LABEL_MODE.ALL ? 'is-active' : null].filter(Boolean).join(' ')}
			aria-pressed={mode === DONUT_PIE_LABEL_MODE.ALL}
			onClick={() => onChange(DONUT_PIE_LABEL_MODE.ALL)}
		>
			全部
		</button>
		<button
			type='button'
			className={['statistics-donut-label-mode__btn', mode === DONUT_PIE_LABEL_MODE.PICK ? 'is-active' : null].filter(Boolean).join(' ')}
			aria-pressed={mode === DONUT_PIE_LABEL_MODE.PICK}
			onClick={() => onChange(DONUT_PIE_LABEL_MODE.PICK)}
		>
			自选
		</button>
	</div>
);

StatisticsDonutLabelModeSwitch.propTypes = {
	mode: PropTypes.oneOf([DONUT_PIE_LABEL_MODE.ALL, DONUT_PIE_LABEL_MODE.PICK]).isRequired,
	onChange: PropTypes.func.isRequired,
};

export default memo(StatisticsDonutLabelModeSwitch);
